export const API_HOST: string = 'https://api.brico-afeb.com';



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/config/config.ts
 **/